module.exports = () => ({
  // Directive that allow to show or hide an element based on the availability of a product
  //
  // Usage:
  //   <div product="PATIENT_LOGIN">
  //
  // Result:
  //   The element is shown only if the product is available
  //
  // See also:
  //   ProductService.isAvailable()
  //
  multiElement: true,
  transclude: 'element',
  restrict: 'A',
  priority: 599,
  terminal: true,
  scope: {
    product: '@',
  },
  $$tlb: true, // enable multi-transclusion, private api MAY broke someday (however never changed since 1.2).
  controllerAs: 'product',
  bindToController: true,
  controller: class {

    static $inject = ['$animate', '$element', '$scope', '$transclude', '$window', 'ProductService'];

    block = null;
    childScope = null;
    previousElements = null;

    constructor($animate, $element, $scope, $transclude, $window, ProductService) {
      this.$animate = $animate;
      this.$element = $element;
      this.$scope = $scope;
      this.$transclude = $transclude;
      this.$window = $window;
      this.ProductService = ProductService;

      this.$scope.$on('session', this.link.bind(this));

      this.link();
    }

    link() {
      if (this.isAvailable()) {
        if (this.childScope) { return; }
        this.$transclude((this.$scope.$parent), (clone, newScope) => {
          this.childScope = newScope;
          clone[clone.length++] = this.$window.document.createComment(` end product: ${this.product} `);
          this.block = { clone };
          this.$animate.enter(clone, this.$element.parent(), this.$element);
        });
      } else {
        if (this.previousElements != null) {
          this.previousElements.remove();
          this.previousElements = null;
        }

        if (this.childScope) {
          this.childScope.$destroy();
          this.childScope = null;
        }

        if (this.block) {
          this.previousElements = getBlockNodes(this.block.clone);
          this.$animate.leave(this.previousElements).then(() => { this.previousElements = null; });
          this.block = null;
        }
      }
    }

    isAvailable() {
      return this.ProductService.isAvailable(this.product);
    }
  },
});



// WEBPACK FOOTER //
// ./main/directives/product.js